import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Section = ({ title, children }) => (
  <section>
    <h2 className="serif text-3xl md:text-4xl tracking-tight text-obsidian mb-4">{title}</h2>
    <div className="space-y-4">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="July 14, 2026">
      <p>
        This Privacy Policy explains how <strong>13150259 Canada Inc.</strong>, operating as
        “RaufMedia” (“we”, “us”, or “our”), collects, uses, and protects your information when you
        visit our website or contact us. By using our website, you agree to the practices described
        below.
      </p>

      <Section title="1. Information We Collect">
        <p>
          We collect information you voluntarily provide through our contact form, including your
          name, email address, company name (optional), service interest, budget range (optional),
          and the contents of your message.
        </p>
        <p>
          We may also automatically collect limited technical data such as your IP address, browser
          type, and pages viewed, for security (spam and abuse prevention) and analytics purposes.
        </p>
      </Section>

      <Section title="2. How We Use Your Information">
        <p>We use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Respond to your inquiries and provide the services you request;</li>
          <li>Send you a confirmation acknowledgment of your submission;</li>
          <li>Protect our website against spam, fraud, and abuse;</li>
          <li>Improve our website, content, and services.</li>
        </ul>
      </Section>

      <Section title="3. Legal Basis & Consent">
        <p>
          We process your personal information on the basis of your consent (given when you submit
          the contact form) and our legitimate interest in responding to and managing business
          inquiries. You may withdraw your consent at any time by contacting us.
        </p>
      </Section>

      <Section title="4. Sharing of Information">
        <p>
          We do not sell your personal information. We may share it with trusted service providers
          who help us operate our website and deliver email (for example, our email delivery
          provider), strictly to perform services on our behalf, and with authorities where required
          by law.
        </p>
      </Section>

      <Section title="5. Data Retention">
        <p>
          We retain contact submissions for as long as necessary to respond to your inquiry and for
          reasonable business record-keeping, after which the data is deleted or anonymized.
        </p>
      </Section>

      <Section title="6. Your Rights">
        <p>
          Depending on your jurisdiction, you may have the right to access, correct, delete, or
          restrict the processing of your personal information. To exercise these rights, contact us
          using the details below.
        </p>
      </Section>

      <Section title="7. Security">
        <p>
          We implement reasonable technical and organizational measures to protect your information.
          However, no method of transmission over the internet is completely secure.
        </p>
      </Section>

      <Section title="8. Contact Us">
        <p>
          If you have questions about this Privacy Policy or your data, contact:
        </p>
        <p className="text-obsidian">
          13150259 Canada Inc. (RaufMedia)<br />
          Email: <a href="mailto:meet@raufmedia.com" className="text-signal">meet@raufmedia.com</a><br />
          Phone: <a href="tel:+16043689865" className="text-signal">+1 604 368 9865</a>
        </p>
      </Section>

      <p className="text-xs text-graphite/70 pt-6 border-t border-black/10">
        This document is provided as a general template and does not constitute legal advice. We
        recommend having it reviewed by qualified legal counsel for your jurisdiction.
      </p>
    </LegalLayout>
  );
}
